import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'containers/ErrorBoundary';

const SuccessRateAlertMF = lazy(() =>
  // eslint-disable-next-line import/no-unresolved
  import('CommonModule/SuccessRateAlerts'),
);

const SuccessRateAlertLazyComponent = props => (
  <Suspense fallback={<></>}>
    <SuccessRateAlertMF {...props} />
  </Suspense>
);

/**
 * This explicit component with ErrorBoundary is needed because when we place
 * ErrorBoundary directly in LazyComponent, error does not get
 * captured by it, and bubbles up to its parent, causing the app crash.
 */
const SuccessRateAlerts = ({
  merchantId,
  merchantName,
  product,
  eventType,
  merchantRoutes,
}) => (
  <ErrorBoundary fallback={<></>}>
    <SuccessRateAlertLazyComponent
      merchantId={merchantId}
      merchantName={merchantName}
      product={product}
      eventType={eventType}
      merchantRoutes={merchantRoutes}
    />
  </ErrorBoundary>
);

SuccessRateAlerts.propTypes = {
  merchantId: PropTypes.number.isRequired,
  merchantName: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
  eventType: PropTypes.string.isRequired,
  merchantRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      merchantRouteId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      credId: PropTypes.number.isRequired,
    }),
  ),
};

export default SuccessRateAlerts;
